import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import RenderProps from 'assets/components/helpers/RenderProps';
import Icon from 'assets/components/icon/Icon';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import { getLocales } from 'assets/locales/Locale';
import ObjectTable from 'assets/templates/objectTable/ObjectTable';
import { get } from 'lodash';
import { useState } from 'react';
import { dispatchPricingDistribution, usePricingDistributionEvent } from './PricingDistributionTable';
import './PricingDistributionTable.scss';

type Props<T> = {
  columnKey: string;
  columns?: string[];
  rows?: T[];
  getPrice: (row: T) => Utils.PricingDistribution;
  updatePrice: (row: T, distribution: Utils.PricingDistribution) => void;
  priceOption?: Utils.RenderProps<{
    row: T;
    distributedValue: Utils.PricingInfo;
    distributionKey: string;
  }>;
  isEditDisabled: boolean;
};
export default function DistributorDistributionTable<T>({
  columnKey,
  columns,
  rows,
  getPrice,
  updatePrice,
  priceOption,
  isEditDisabled,
}: Props<T>) {
  const [isOpen, setIsOpen] = useState(false);
  usePricingDistributionEvent(
    {
      callback: (event) => {
        setIsOpen((old) => (columnKey === event.id ? !old : false));
      },
    },
    [columnKey]
  );
  const { lang } = getLocales();
  return (
    <>
      <Button
        class={ThemeButtonCircle}
        style={{ button: { display: 'inline-block' } }}
        media="fas-users"
        active={isOpen}
        onClick={dispatchPricingDistribution}
        data={{ data: { id: columnKey } }}
        disabled={!columns?.length || !rows?.length}
        htmlElementProps={{ title: lang.openDistributorDistributionTable }}
      />
      {isOpen && (
        <ObjectTable
          className={'PricingDistributionTable'}
          paths={columns}
          data={rows}
          focusOnLoad
          translateHeader
          render={({ path: col, data: row }) => {
            const distribution = getPrice(row);
            const distributedValue = get(distribution, col);
            return (
              <td key={col}>
                <NumberInput
                  name="amount"
                  value={distributedValue?.amount}
                  htmlElementProps={{ title: col.replace(/\./gi, ' | ') }}
                  onChange={({ amount }) =>
                    updatePrice(row, {
                      ...distribution,
                      [col]: { amount, currency: 'CAD' },
                    })
                  }
                  style={{
                    formInput: {
                      minWidth: '157px',
                    },
                    input: {
                      textAlign: 'right',
                    },
                  }}
                  icon={<Icon class={'fas-dollar-sign'} />}
                  min={0}
                  step={0.01}
                  roundOnBlur
                  iconBefore={RenderProps({ priceOption }, 'priceOption', {
                    row,
                    distributedValue,
                    distributionKey: col,
                  })}
                  disabled={!isEditDisabled}
                />
              </td>
            );
          }}
        />
      )}
    </>
  );
}
